module.exports = __webpack_public_path__ + "img/search-game.d5d69417.jpeg";